import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { AuthStore, AuthStoreModel } from '../../models/auth-store/auth-store';
import { LanguageStore, LanguageStoreModel } from '../../models/language-store/language-store';
import { UserStore, UserStoreModel } from '../../models/user-store/user-store';
import { AccVmIpStore, IAccVmIpStore } from '../acc-vm-ip-store/AccVmIpStore';
import { CommonCodeStore, ICommonCodeStore } from '../common-code-store/CommonCodeStore';
import { ErrorAlertStore, IErrorAlertStore } from '../error-alert-store/ErrorAlertStore';
import { IInfraImageStore, InfraImageStore } from '../infra-image-store/InfraImageStore';
import {
  IInfraManagementStore,
  InfraManagementStore,
} from '../infra-management-store/InfraManagementStore';
import { ILoadingStore, LoadingStore } from '../loading-store/LoadingStore';
import { IReportStore, ReportStore } from '../report-store/ReportStore';
import { IResponseStore, ResponseStore } from '../response-store/ResponseStore';
import { IServiceHistStore, ServiceHistStore } from '../service-hist-store/ServiceHistStore';
import {
  ISystemSettingStore,
  SystemSettingStore,
} from '../system-setting-store/SystemSettingStore';
import { IUserGroupStore, UserGroupStore } from '../user-group-store/UserGroupStore';

export const RootStoreModel = types.model('RootStore').props({
  userStore: types.optional(UserStoreModel, {} as UserStore),
  authStore: types.optional(AuthStoreModel, {} as AuthStore),
  userGroupStore: types.optional(UserGroupStore, {} as IUserGroupStore),
  sysSettingStore: types.optional(SystemSettingStore, {} as ISystemSettingStore),
  languageStore: types.optional(LanguageStoreModel, {} as LanguageStore),
  errorAlertStore: types.optional(ErrorAlertStore, {} as IErrorAlertStore),
  responseStore: types.optional(ResponseStore, {} as IResponseStore),
  loadingStore: types.optional(LoadingStore, {} as ILoadingStore),
  commonCodeStore: types.optional(CommonCodeStore, {} as ICommonCodeStore),

  reportStore: types.optional(ReportStore, {} as IReportStore),
  infraImageStore: types.optional(InfraImageStore, {} as IInfraImageStore),
  serviceHistManagementStore: types.optional(ServiceHistStore, {} as IServiceHistStore),
  accVmIpManagementStore: types.optional(AccVmIpStore, {} as IAccVmIpStore),
  infraManagementStore: types.optional(InfraManagementStore, {} as IInfraManagementStore),
});

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
